module.exports = __webpack_public_path__ + "img/widget.707d0893.png";